import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Component from "./component";
import { fetchBrands } from "../pre-delivery-inspection/actions";
import { setDetails } from "../pre-delivery-inspection-user-flow/actions";

const mapStateToProps = ({
    brands: { all: brandList },
    preDeliveryInspectionLeadData: { brand } }) => {
    return {
        brandList,
        brand
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        fetchBrandsConnect: fetchBrands,
        setDetailsConnect: setDetails
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Component);
